<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container p-0 pb-3">

    <select class="form-control fileselect" v-bind:id="'select_' +  getId()" data-fouc v-on:change="onChange" v-select>
      <option value="" style="">{{placeholder}}</option>
      <option v-for="option in fileInfos" v-bind:value="option.url" v-bind:data-icon="option.extension">
        {{ option.name }}
      </option>
    </select>

    <input type="hidden" v-bind:name="'selectedFile' + this.name" v-bind:value="selected" />

    <div v-if="progressInfos">
      <div class="mb-2"
           v-for="(progressInfo, index) in progressInfos"
           :key="index">
        <span>{{progressInfo.fileName}}</span>
        <div class="progress">
          <div class="progress-bar progress-bar-info"
               role="progressbar"
               :aria-valuenow="progressInfo.percentage"
               aria-valuemin="0"
               aria-valuemax="100"
               :style="{ width: progressInfo.percentage + '%' }">
            {{progressInfo.percentage}}%
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3" v-if="visible == true">
      <div class="col-6">
        <input type="file" multiple @change="selectFile" class="h-auto" v-bind:accept="getAccepts()" />
      </div>
      <div class="col-6" style="text-align:right">
        <button class="btn skin primary-button"
                :disabled="!selectedFiles"
                @click="uploadFiles">
          {{buttontext}}
        </button>
      </div>
    </div>

    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>



  </div>
</template>

<script>


  import UploadService from "../services/UploadFilesService";

  let message = "";
  var selected = "";
  var fileInfos = [];
  var placeholder = "";
  var buttontext = "";

  export default {
    name: "upload-file-selector",
    props: {

      uid: {
        type: String,
        default: null
      },
      visibility: {
        type: Boolean,
        default: true
      },
      filter: {
        type: String,
        default: null
      },
      selectedfile: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: 'name_missing'
      },
      value: {
        type: String,
        default: null
      },
      id: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        placeholder,
        buttontext,
        selectedfileProp: this.selectedfile,
        selected,
        selectedFiles: undefined,
        progressInfos: [],
        message: "",
        fileInfos,
        visible: this.visibility
      };
    },
    methods: {
      getOptionStyle(v) {
        return v;
      },
      onChange() {
        //alert('setting file:' + $("#" + 'select_' + this.getId()).val(), $("#" + 'select_' + this.getId() + ' option:selected').text())
        this.$emit('change', $("#" + 'select_' + this.getId()).val(), $("#" + 'select_' + this.getId() + ' option:selected').text());
        //this.$parent.close();
      },
      input(event) {
        this.$emit('input', event.target.value);
      },
      getId() {
        return this._uid;
      },
      getAccepts() {
        if (typeof this.filter != "undefined" && this.filter != null) {
          var dottedFilter = "";
          var filterArray = this.filter.split(',');
          var limiter = "";
          for (var i = 0; i < filterArray.length; i++) {
            dottedFilter += limiter + "." + filterArray[i];
            limiter = ",";
          }
          return dottedFilter;
        }
        return "";
      },
      selectFile(event) {
        this.progressInfos = [];
        this.selectedFiles = event.target.files;
      },
      doChange() {
        this.selected = $("#" + 'select_' + this.getId()).val();
      },
      upload(uid, idx, file) {
        this.progressInfos[idx] = { percentage: 0, fileName: file.name };

        UploadService.upload(uid, file, null, null,"", false, false, (event) => {
          this.progressInfos[idx].percentage = Math.round(100 * event.loaded / event.total);
        }).then((response) => {

          let prevMessage = this.message ? this.message + "\n" : "";
          this.message = prevMessage + response.data.message;

          return UploadService.getFiles(uid, this.filter);
        })
          .then((files) => {
            this.fileInfos = files.data;
          })
          .catch(() => {
            this.progressInfos[idx].percentage = 0;
            this.message = "Could not upload the file:" + file.name;
          });
      },

      uploadFiles() {
        this.message = "";
        if (this.selectedFiles == null || this.selectedFiles.length == 0)
          return;

        for (let i = 0; i < this.selectedFiles.length; i++) {
          this.upload(this.uid, i, this.selectedFiles[i]);
        }

        //e.preventDefault();
        return false;
      }
    },
    watch: {
      selectedfile: function (newVal, oldVal) {
        $("#select_" + this.getId()).val(newVal);
        $("#select_" + this.getId()).trigger('change');

      }
    },
    mounted() {
      /*
      UploadService.getFiles(this.uid, this.filter).then((response) => {
        this.fileInfos = response.data;
      }).then(() => {
        if (typeof this.selectedfileProp != null) {
          $("#select_" + this.getId()).val(this.selectedfileProp);
          $("#select_" + this.getId()).trigger('change');
        }
      });
      */
      $("#select_" + this.getId()).change(this.doChange);

      this.placeholder = this.$t('select_file');
      this.buttontext = this.$t('upload');

    }


  };
</script>



// WEBPACK FOOTER //
// src/components/upload/upload-file-selector.vue